// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimItemCorrectionResponseDTO } from '../models';
import { UpdateClaimItemCorrectionDTO } from '../models';
/**
 * ClaimItemCorrectionsApi - axios parameter creator
 * @export
 */
export const ClaimItemCorrectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Apply a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling applyClaimItemCorrection.');
            }
            // verify required parameter 'updateClaimItemCorrectionDTO' is not null or undefined
            if (updateClaimItemCorrectionDTO === null || updateClaimItemCorrectionDTO === undefined) {
                throw new RequiredError('updateClaimItemCorrectionDTO','Required parameter updateClaimItemCorrectionDTO was null or undefined when calling applyClaimItemCorrection.');
            }
            const localVarPath = `/v2/claim-item-corrections/{claimItemId}`
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateClaimItemCorrectionDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateClaimItemCorrectionDTO !== undefined ? updateClaimItemCorrectionDTO : {}) : (updateClaimItemCorrectionDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling dryRunClaimItemCorrection.');
            }
            // verify required parameter 'updateClaimItemCorrectionDTO' is not null or undefined
            if (updateClaimItemCorrectionDTO === null || updateClaimItemCorrectionDTO === undefined) {
                throw new RequiredError('updateClaimItemCorrectionDTO','Required parameter updateClaimItemCorrectionDTO was null or undefined when calling dryRunClaimItemCorrection.');
            }
            const localVarPath = `/v2/claim-item-corrections/{claimItemId}/dry-run`
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateClaimItemCorrectionDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateClaimItemCorrectionDTO !== undefined ? updateClaimItemCorrectionDTO : {}) : (updateClaimItemCorrectionDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimItemCorrectionsApi - functional programming interface
 * @export
 */
export const ClaimItemCorrectionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Apply a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemCorrectionResponseDTO> {
            const localVarAxiosArgs = ClaimItemCorrectionsApiAxiosParamCreator(configuration).applyClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Preview a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemCorrectionResponseDTO> {
            const localVarAxiosArgs = ClaimItemCorrectionsApiAxiosParamCreator(configuration).dryRunClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimItemCorrectionsApi - factory interface
 * @export
 */
export const ClaimItemCorrectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Apply a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any) {
            return ClaimItemCorrectionsApiFp(configuration).applyClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options)(axios, basePath);
        },
        /**
         * Preview a claim item correction
         * @param {string} claimItemId Claim item id
         * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any) {
            return ClaimItemCorrectionsApiFp(configuration).dryRunClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options)(axios, basePath);
        },
    };
};

/**
 * ClaimItemCorrectionsApi - interface
 * @export
 * @interface ClaimItemCorrectionsApi
 */
export interface ClaimItemCorrectionsApiInterface {
    /**
     * Apply a claim item correction
     * @param {string} claimItemId Claim item id
     * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemCorrectionsApiInterface
     */
    applyClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any): AxiosPromise<ClaimItemCorrectionResponseDTO>;

    /**
     * Preview a claim item correction
     * @param {string} claimItemId Claim item id
     * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemCorrectionsApiInterface
     */
    dryRunClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any): AxiosPromise<ClaimItemCorrectionResponseDTO>;

}

/**
 * ClaimItemCorrectionsApi - object-oriented interface
 * @export
 * @class ClaimItemCorrectionsApi
 * @extends {BaseAPI}
 */
export class ClaimItemCorrectionsApi extends BaseAPI implements ClaimItemCorrectionsApiInterface {
    /**
     * Apply a claim item correction
     * @param {string} claimItemId Claim item id
     * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemCorrectionsApi
     */
    public applyClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any) {
        return ClaimItemCorrectionsApiFp(this.configuration).applyClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options)(this.axios, this.basePath);
    }

    /**
     * Preview a claim item correction
     * @param {string} claimItemId Claim item id
     * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemCorrectionsApi
     */
    public dryRunClaimItemCorrection(claimItemId: string, updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO, options?: any) {
        return ClaimItemCorrectionsApiFp(this.configuration).dryRunClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimItemCorrectionsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Apply a claim item correction
 * @param {string} claimItemId Claim item id
 * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function applyClaimItemCorrection(
    claimItemId: string,
    updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemCorrectionResponseDTO> {
    const localVarAxiosArgs = ClaimItemCorrectionsApiAxiosParamCreator(configuration).applyClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Preview a claim item correction
 * @param {string} claimItemId Claim item id
 * @param {UpdateClaimItemCorrectionDTO} updateClaimItemCorrectionDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function dryRunClaimItemCorrection(
    claimItemId: string,
    updateClaimItemCorrectionDTO: UpdateClaimItemCorrectionDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemCorrectionResponseDTO> {
    const localVarAxiosArgs = ClaimItemCorrectionsApiAxiosParamCreator(configuration).dryRunClaimItemCorrection(claimItemId, updateClaimItemCorrectionDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

